function getSource() {
  const ua = window.navigator.userAgent.toLowerCase();
  let source = '';
  if (/micromessenger/i.test(ua)) {
    source = 'wx_app';
  } else {
    source = 'app';
  }
  return source;
}

function getStorageItem(key) {
  return localStorage.getItem(key);
}

function setStorageItem(key, value) {
  window.localStorage.setItem(key, value);
}

function getCookieItem(key) {
  const cookieData = document.cookie;
  if (cookieData.length > 0) {
    let startData = cookieData.indexOf(`${key}=`);
    if (startData !== -1) {
      startData = startData + key.length + 1;
      let endData = cookieData.indexOf(';', startData);
      if (endData === -1) {
        endData = cookieData.length;
      }
      return unescape(cookieData.substring(startData, endData));
    }
  }
  return '';
}

const expiredays = 365;

function setCookieItem(key, value) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = `${key}=${escape(value)}${(expiredays === null) ? '' : `;expires=${exdate.toUTCString()}`}`;
}

const source = getSource();

const LocalStorage = {
  set(key, value) {
    // 微信小程序环境无法使用localStorage，故存入cookie
    if (source === 'wx_app') {
      setCookieItem(key, value);
    } else {
      setStorageItem(key, value);
    }
  },

  get(key) {
    if (source === 'wx_app') {
      return getCookieItem(key);
    }
    return getStorageItem(key);
  },
};

export default LocalStorage;



// WEBPACK FOOTER //
// ./src/utils/LocalStorage/index.js